import React from "react";
import { Helmet } from "react-helmet-async";

const StructuredData = () => {
  // Create JSON-LD data for the organization
  const organizationData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Pathshala Sanchalak",
    url: "https://pathshalasanchalak.in",
    logo: "https://pathshalasanchalak.in/logo512.png",
    sameAs: [
      "https://www.facebook.com/pathshalasanchalak",
      "https://twitter.com/pathshalasanchalak",
      "https://www.linkedin.com/company/pathshala-sanchalak",
      "https://www.instagram.com/pathshalasanchalak",
    ],
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+91-XXXXXXXXXX",
      contactType: "customer service",
      availableLanguage: ["English", "Hindi"],
    },
    description:
      "Pathshala Sanchalak provides comprehensive school management systems and coaching management software to educational institutions across India. Our solutions help schools, coaching centers, and tuition providers efficiently manage students, faculty, courses, fees, and academic operations with our all-in-one education ERP platform.",
    keywords: "school management system, coaching management software, education ERP software, student management system India",
    address: {
      "@type": "PostalAddress",
      addressCountry: "India"
    },
    foundingDate: "2020-01-01"
  };

  // Create JSON-LD data for the SoftwareApplication
  const softwareApplicationData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "Pathshala Sanchalak - School & Coaching Management System",
    applicationCategory: "EducationalApplication, BusinessApplication",
    operatingSystem: "Web, iOS, Android",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "INR",
      availability: "https://schema.org/InStock",
      priceValidUntil: "2025-12-31",
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: "4.8",
      ratingCount: "152",
      bestRating: "5",
      worstRating: "1"
    },
    applicationSubCategory: "School Management System, Coaching Management System",
    featureList:
      "Student Management, Faculty Management, Course Management, Fee Management, Attendance Tracking, Performance Analytics, Online Classes",
    screenshot: "https://pathshalasanchalak.in/screenshots/dashboard.png",
    softwareHelp: "https://pathshalasanchalak.in/support",
    keywords: "school management system, coaching management system, education ERP, student management"
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationData)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(softwareApplicationData)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
